import React from 'react';
import Icon from '../../../components/AppIcon';

const ReferenceDisplay = ({ reference }) => {
  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name="Hash" size={20} className="text-primary" />
          </div>
          <div>
            <p className="text-xs text-muted-foreground">Référence générée</p>
            <p className="text-lg font-semibold text-primary">{reference}</p>
          </div>
        </div>
        <div className="flex items-center space-x-2 text-success">
          <Icon name="CheckCircle" size={20} />
          <span className="text-sm font-medium">Auto-généré</span>
        </div>
      </div>
    </div>
  );
};

export default ReferenceDisplay;